import { generatePath } from 'react-router-dom';

import type { Report } from 'src/types/report';
import { apiPaths } from 'src/services/api/apiPaths';
import HttpService from 'src/services/api/http';

type ReportCompare = Pick<
  Report,
  'organisational_unit' | 'report_type' | 'file_type'
>;

/**
 * The primary key is not directly connected to the file which means that
 * different reports might be shown in separate location but ultimately point
 * to the same file. This helper function allows to identify such reports.
 * @param report1
 * @param report2
 */
export const reportEqualPredicate = (
  report1: ReportCompare,
  report2: ReportCompare,
) =>
  report1.organisational_unit === report2.organisational_unit &&
  report1.report_type === report2.report_type &&
  report1.file_type === report2.file_type;

export const reportUnEqualFunction =
  (report1: ReportCompare) => (report2: ReportCompare) =>
    !reportEqualPredicate(report1, report2);

export const getReportsBundlePayload = (
  reports: Report[],
  language: number,
) => ({
  reports: reports.map((report) => ({
    file_type: report.file_type,
    organisational_unit: report.organisational_unit,
    report_type: report.report_type,
  })),
  language: language,
});

export const orderReport = (reportId: number) =>
  HttpService.patch(generatePath(apiPaths.ORDER_REPORT, { id: reportId }), {})
    .then(() => 'success')
    .catch(() => 'error');
